(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oliw87-video-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oliw87-video-home')) {
    customElements.define('oliw87-video-home', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const video = this.querySelector('video');
        const button = this.querySelector('.oliw87-vh__playback');
        const clock = this.querySelector('.oliw87-vh__clock');
        const status = this.querySelector('.oliw87-vh__status');
        if (!video || !button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let userPaused = motion.matches;
        let failed = false;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        button.hidden = false;
        const sync = () => {
          button.textContent = video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        };
        const play = () => {
          if (!this.isConnected || failed || userPaused || document.hidden) return;
          video.muted = true;
          const attempt = video.play();
          if (attempt) attempt.catch(sync);
        };
        const showPoster = () => {
          failed = true;
          video.pause();
          video.hidden = true;
          button.hidden = true;
          status.textContent = this.dataset.errorLabel;
        };
        video.addEventListener('playing', sync, options);
        video.addEventListener('pause', sync, options);
        video.addEventListener('error', showPoster, options);
        video.querySelectorAll('source').forEach(source => {
          source.addEventListener('error', () => {
            if (video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) showPoster();
          }, options);
        });
        button.addEventListener('click', () => {
          if (video.paused) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
        }, options);
        motion.addEventListener('change', event => {
          if (event.matches) {
            userPaused = true;
            video.pause();
          }
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) video.pause();
          else play();
        }, options);
        if (clock) {
          const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Stockholm', day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
          });
          const updateClock = () => {
            const now = new Date();
            clock.dateTime = now.toISOString();
            clock.textContent = formatter.format(now);
            clock.hidden = false;
          };
          updateClock();
          this.clockTimer = window.setInterval(updateClock, 30000);
        }
        if (userPaused) {
          video.removeAttribute('autoplay');
          video.pause();
        } else {
          play();
        }
        sync();
        if (video.error) showPoster();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        window.clearInterval(this.clockTimer);
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oliw87-video-password"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oliw87-password')) {
    customElements.define('oliw87-password', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const video = this.querySelector('video');
        const playButton = this.querySelector('.opd-playback');
        const status = this.querySelector('[data-video-status]');
        const popup = this.querySelector('.opd-collector-dialog');
        const password = this.querySelector('.opd-password-dialog');
        const passwordTrigger = this.querySelector('[data-open-password]');
        const collectorTrigger = this.querySelector('[data-open-collector]');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const editor = this.dataset.editor === 'true';
        const seenKey = 'oliw87-collector-popup-seen';
        const subscribedKey = 'oliw87-collector-signup-complete';
        let userPaused = motion.matches;
        let videoFailed = false;
        let visitorInteracted = false;
        const readStorage = key => { try { return sessionStorage.getItem(key) === '1'; } catch { return false; } };
        const writeStorage = key => { if (!editor) { try { sessionStorage.setItem(key, '1'); } catch {} } };
        const cancelPopup = () => { window.clearTimeout(this.popupTimer); this.popupTimer = null; };
        const openDialog = (dialog, focusTarget) => {
          cancelPopup();
          if (popup.open) popup.close();
          if (password.open) password.close();
          if (dialog === popup) writeStorage(seenKey);
          dialog.showModal();
          const target = focusTarget || dialog.querySelector('[data-close]');
          target?.focus({ preventScroll: true });
        };
        passwordTrigger.hidden = false;
        collectorTrigger.hidden = this.dataset.popupEnabled !== 'true';
        passwordTrigger.addEventListener('click', () => openDialog(password), options);
        collectorTrigger.addEventListener('click', () => openDialog(popup), options);
        [popup, password].forEach(dialog => {
          dialog.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => dialog.close(), options));
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          }, options);
        });
        this.querySelectorAll('form').forEach(form => {
          form.addEventListener('focusin', () => { visitorInteracted = true; cancelPopup(); }, options);
          form.addEventListener('submit', () => { visitorInteracted = true; cancelPopup(); }, options);
        });
        const passwordError = password.querySelector('[data-password-error]');
        const signupSuccess = this.querySelector('[data-signup-success]');
        const signupError = this.querySelector('[data-signup-error]');
        const popupReturn = window.location.hash.includes('Oliw87PopupCollector-');
        if (signupSuccess) {
          writeStorage(subscribedKey);
          const popupSuccess = popup.querySelector('[data-signup-success]');
          if (popupSuccess) {
            popup.querySelector('[data-collector-intro]').hidden = true;
            popup.setAttribute('aria-labelledby', popupSuccess.id);
            popup.removeAttribute('aria-describedby');
          }
        }
        if (passwordError) openDialog(password, passwordError);
        else if (popupReturn && (signupSuccess || signupError)) openDialog(popup, popup.querySelector('[data-signup-success], [data-signup-error]'));
        else if (signupSuccess || signupError) this.querySelector('.opd-main [data-signup-success], .opd-main [data-signup-error]')?.focus({ preventScroll: true });
        else if (editor && this.dataset.previewPopup === 'true') openDialog(popup);
        else if (!editor && this.dataset.popupEnabled === 'true' && !readStorage(seenKey) && !readStorage(subscribedKey)) {
          this.popupTimer = window.setTimeout(() => {
            if (this.isConnected && !document.hidden && !visitorInteracted && !password.open && !popup.open) openDialog(popup);
          }, Math.max(0, Number(this.dataset.popupDelay) || 8) * 1000);
        }
        const syncVideo = () => { playButton.textContent = video.paused ? this.dataset.playLabel : this.dataset.pauseLabel; };
        const play = () => {
          if (!this.isConnected || document.hidden || userPaused || videoFailed) return;
          video.muted = true;
          const attempt = video.play();
          if (attempt) attempt.catch(syncVideo);
        };
        const showPoster = () => {
          videoFailed = true;
          video.pause();
          video.hidden = true;
          playButton.hidden = true;
          status.textContent = this.dataset.videoError;
        };
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        playButton.hidden = false;
        video.addEventListener('playing', syncVideo, options);
        video.addEventListener('pause', syncVideo, options);
        video.addEventListener('error', showPoster, options);
        video.querySelectorAll('source').forEach(source => source.addEventListener('error', () => {
          if (video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) showPoster();
        }, options));
        playButton.addEventListener('click', () => {
          if (video.paused) { userPaused = false; play(); }
          else { userPaused = true; video.pause(); }
        }, options);
        motion.addEventListener('change', event => { if (event.matches) { userPaused = true; video.pause(); } }, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); }, options);
        if (userPaused) { video.removeAttribute('autoplay'); video.pause(); } else play();
        syncVideo();
        if (video.error) showPoster();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        window.clearTimeout(this.popupTimer);
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
